export default {
	"accountSettings.title": "Account Settings",
	"accountSettings.email.label": "Email",
	"accountSettings.username.label": "Username",
	"accountSettings.username.button.save": "Save Change",
	"accountSettings.username.button.cancel": "Cancel",
	"accountSettings.username.message.failed": "The username should be less than 20 characters.",
	"accountSettings.password.label": "Password",
	"accountSettings.password.button.change": "Change Password",
	"accountSettings.password.modal.title": "Change Password",
	"accountSettings.password.modal.label.original": "Original Password",
	"accountSettings.password.modal.label.new": "New Password",
}
